import * as platformGather from './gather'

const getCurrentPlatform = () => {
  const platform = Object.keys(platformGather)
    .filter((item) => platformGather[item].is())
    .pop();
  return platform ? platformGather[platform] : platformGather.m
}

export const platform = getCurrentPlatform()